import React from 'react';

import _ from '@ihme/common/locale';
import styled from '@ihme/common/theme/styled';

import PageHeader from '../../components/PageHeader';
import ChartHighlight from '../../components/ChartHighlight';
import MapChartSection from './MapChartSection';

const PageContainer = styled.div(({ theme }) => ({
    paddingBottom: 50,
}));

class GlobalImpactScene extends React.Component {
    render() {
        return (
            <PageContainer>
                <PageHeader>{_('global_impact_scene_title')}</PageHeader>
                <ChartHighlight>{_('global_impact_description')}</ChartHighlight>
                <MapChartSection />
            </PageContainer>
        );
    }
}

export default GlobalImpactScene;
